
  import { defineComponent, PropType } from 'vue';

  import { FTS_INDICATOR_TYPE_FILTER_OPTIONS } from '../../constants/fts/options';
  import { IndicatorTypes } from '../../types/common-aggregated';
  import FTSFilterWrapperRadio from './fts-filter/FTSFilterWrapperRadio.vue';

  export default defineComponent({
    name: 'FTSIndicatorTypeField',
    components: { FTSFilterWrapperRadio },
    props: {
      modelValue: {
        type: Number as PropType<IndicatorTypes>,
        required: true,
      },
    },
    emits: ['update:modelValue'],
    computed: {
      tradeDirectionAccessor: {
        get() {
          return this.modelValue;
        },
        set(newValue: IndicatorTypes) {
          this.$emit('update:modelValue', newValue);
        },
      },
      getIdicatorTypesOptions() {
        return FTS_INDICATOR_TYPE_FILTER_OPTIONS;
      },
    },
  });
